import {MediaType} from "../store";

export const parseMedia = (contentType: string | undefined): MediaType | undefined => {
  return contentType?.startsWith('image/')
    ? MediaType.IMAGE
    : contentType?.startsWith("video/")
      ? MediaType.VIDEO
      : undefined;
}